export default __webpack_public_path__ + "static/media/whatsapp.c32dc261.svg";